// @flow
import * as most from 'most';
import { curryN } from 'ramda';

const curry2 = curryN(2);

export const map = curry2(most.map);
export const debounce = curry2(most.debounce);
export const filter = curry2(most.filter);
export const tap = curry2(most.tap);
export const recoverWith = curry2(most.recoverWith);
export const delay = curry2(most.delay);
